module.exports = function getResource(label) {
    const resources = {
        signInText: 'Ouvrir une session'
    };

    return resources[label];
};
